import {
  Button,
  Loading,
  MenuCustom,
  Card,
  CardHeader,
  CardContent,
  CardActions,
} from "../../components";
import "./flex.layout.scss";

const FlexLayout = ({
  id,
  formAction,
  onClickSalvar,
  loading,
  title,
  codigo,
  ButtonMenu,
  actions,
  footerActions,
  children,
  nonSubmit,
}) => {
  return (
    <div className="flex-layout-container">
      {ButtonMenu && <MenuCustom codigo={codigo} ButtonMenu={ButtonMenu} />}

      <Card className="flex-layout-card">
        <CardHeader title={title} action={actions} botaoVoltar={!ButtonMenu} />

        <CardContent className="flex-layout-card-content rolagem">
          <div style={{ padding: "0 4px" }}>{children}</div>
        </CardContent>

        <div className="flex-actions-container">
          {!nonSubmit && (
            <CardActions className="flex-main-actions">
              <Button
                type={formAction ? "submit" : "button"}
                form={formAction ? "form" : undefined}
                onClick={(event) => !formAction && onClickSalvar(event)}
                variant="contained"
                color="primary"
                className="flex-save-button"
              >
                {id ? "ATUALIZAR" : "SALVAR"}
              </Button>
            </CardActions>
          )}

          {footerActions && (
            <CardActions className="flex-footer-actions">
              {footerActions}
            </CardActions>
          )}
        </div>
      </Card>

      <Loading loading={loading} />
    </div>
  );
};

export default FlexLayout;
